import { get, post, postRegis } from "./api_helper";
import * as url from "./url_helper";

export const getSettings = (params) => {
  return get(url.GET_SETTING, params);
};

export const getRules = (params) => {
  return post(url.GET_RULES, params);
};

export const getRegistration = (params) => {
  return postRegis(url.GET_REGISTRATION, params);
};

export const getUserInFo = (guid) => {
  return get(url.GET_USER_INFO(guid));
};
